import ajax from '../utils/request'

const authorApi = {
  /********************************主后台权限管理*********************************** */
  // 删除权限
  delAuthor(params) {
    return ajax({
      url: '/author/del',
      type: 'delete',
      params: params
    })
  },
  // 获取权限/角色列表
  getAuthorList(params) {
    return ajax({
      url: '/author/list',
      type: 'get',
      params: params
    })
  },
  // 修改权限
  updateAuthor(params) {
    return ajax({
      url: '/author/update',
      type: 'post',
      params: params
    })
  },
  // 添加角色
  addAuthor(params) {
    return ajax({
      url: '/author/add',
      type: 'post',
      params: params
    })
  },

}
export default authorApi